var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"roll-history"},[_c('div',{staticClass:"history-title"},[_vm._v("PREVIOUS ROLLS")]),_c('transition-group',{staticClass:"history-list",attrs:{"name":"list","tag":"div"}},_vm._l((_vm.rollHistory),function(game){return _c('RollHistoryElement',{key:game._id,attrs:{"game":game}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }